import React from 'react';
import {AutocompleteDictionary} from './autocomplete';
import AgyleDictionaryField from '../../components/ui/selector/agyleDictionaryField';
import {useSelector} from 'react-redux';
import {
    activityTreatment,
    attendanceCategory,
    clinicianIssuerCode,
    clinicianTier,
    consultationMechanism,
    departmentType,
    mentalHealthClassification,
    nhsNoVerificationStatuses,
    overseasVisitorChargingCategory,
    referralTreatmentStatus,
    waitingTimeMeasurementType,
    withheldIdentityReason,
} from '../../store/reducers/dicts';
import {filterOptions} from './ecds';
import Chip from '@mui/material/Chip';
import {AutocompleteDropdownDictionary} from './autocompleteDropdown';

function ReferralTreatmentStatus(props) {
    const dict = useSelector(referralTreatmentStatus);
    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function WaitingTimeMeasurementType(props) {
    const dict = useSelector(waitingTimeMeasurementType);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function WithheldIdentityReason(props) {
    const dict = useSelector(withheldIdentityReason);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function OverseasVisitorChargingCategory(props) {
    const dict = useSelector(overseasVisitorChargingCategory);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function MentalHealthClassification(props) {
    const dict = useSelector(mentalHealthClassification);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function DepartmentType(props) {
    const dict = useSelector(departmentType);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function AttendanceCategory(props) {
    const dict = useSelector(attendanceCategory);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function ConsultationMechanism(props) {
    const dict = useSelector(consultationMechanism);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function ActivityTreatment(props) {
    const getDictionaryURL = (filter) => {
        return `/$dict/ActivityTreatment?$filter=${encodeURIComponent(filter)}&$pageSize=10&$page=1`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return <AutocompleteDictionary getOptionLabel={option => option.__description}
                                   getOptionSelected={(option, value) => option.__id === value.__id}
                                   searchColumnName={'description'}
                                   renderLocalOption={renderOptionLine}
                                   dictionaryURL={getDictionaryURL}
                                   {...props}
    />;
}

function ActivityTreatmentECDS(props) {
    const dict = useSelector(activityTreatment);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function ClinicianIssuerCode(props) {
    const dict = useSelector(clinicianIssuerCode);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function ClinicianTier(props) {
    const dict = useSelector(clinicianTier);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function DelayReason(props) {
    const getDictionaryURL = (filter) => {
        return `/$dict/DelayReason?$filter=${encodeURIComponent(filter)}`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return <AutocompleteDictionary getOptionLabel={option => option.__description}
                                   getOptionSelected={(option, value) => option.__id === value.__id}
                                   searchColumnName={'description'}
                                   showAll
                                   renderLocalOption={renderOptionLine}
                                   dictionaryURL={getDictionaryURL}
                                   {...props}
    />;
}

function ClinicalFrailtyScale(props) {
    const getDictionaryURL = (filter) => {
        return `/$dict/ClinicalFrailtyScale?$filter=${encodeURIComponent(filter)}&$sort=code`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return <AutocompleteDictionary getOptionLabel={option => option.__description}
                                   getOptionSelected={(option, value) => option.__id === value.__id}
                                   searchColumnName={'description'}
                                   renderLocalOption={renderOptionLine}
                                   dictionaryURL={getDictionaryURL}
                                   showAll
                                   {...props}
    />;
}

function NHSStatusCode(props) {
    const dict = useSelector(nhsNoVerificationStatuses);

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

function ObsSuspendReason(props) {
    const getDictionaryURL = (filter) => {
        let newFilter = 'deactivated ne true';

        if (filter !== '') {
            newFilter = `(${filter} and deactivated ne true)`;
        }

        return `/$dict/ObservationSuspendReasons?$filter=${encodeURIComponent(newFilter)}&$sort=description`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return <AutocompleteDictionary getOptionLabel={option => option.__description}
                                   getOptionSelected={(option, value) => option.__id === value.__id}
                                   searchColumnName={'description'}
                                   renderLocalOption={renderOptionLine}
                                   dictionaryURL={getDictionaryURL}
                                   showAll
                                   {...props}
    />;
}

function AttendanceType(props) {
    const getDictionaryURL = (filter) => {
        if (props.showAll) {
            return `/$dict/AdmissionMethods?$filter=${encodeURIComponent('group eq \'Agyle\'')}`;
        }
        return `/$dict/AttendanceTypes?$filter=${encodeURIComponent(
            filter,
        )}&$sort=sort1&$pageSize=10&$page=1`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return (
        <AutocompleteDictionary
            getOptionLabel={(option) => option.__description}
            showAll
            renderLocalOption={renderOptionLine}
            searchColumnName={'description'}
            dictionaryURL={getDictionaryURL}
            {...props}
        />
    );
}

function Location(props) {
    const getDictionaryURL = (filter) => {
        if (props.fromAdmit) {
            return `/$dict/AttendanceTypes?$filter=${encodeURIComponent(
                filter,
            )}&$sort=description&$pageSize=10&$page=1`;
        }
        return `/$dict/AttendanceTypes?$filter=${encodeURIComponent(
            filter,
        )}&$sort=sort1&$pageSize=10&$page=1`;
    };
    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return (
        <AutocompleteDictionary
            getOptionLabel={(option) => option.__description}
            showAll
            searchColumnName={'description'}
            renderLocalOption={renderOptionLine}
            dictionaryURL={getDictionaryURL}
            {...props}
        />
    );
}

//TODO: check where it is used!!!!
function Consultants(props) {
    const getDictionaryURL = (filter) => {
        return `/consultants?&$filter=(inactive ne true) AND deactivated ne true  ${filter ? (' and ' + filter) : ''}&$pageSize=20&$page=1`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        let name = option.title != null ? option.title + ' ' : '';
        name += option.firstName != null ? option.firstName + ' ' : '';
        name += option.familyName != null ? option.familyName + ' ' : '';

        return <div {...inp}> {name ? name : option.name} </div>;
    };
    return (
        <AutocompleteDictionary
            getOptionLabel={c => {
                let name = c.title != null ? c.title + ' ' : '';
                name += c.firstName != null ? c.firstName + ' ' : '';
                name += c.familyName != null ? c.familyName + ' ' : '';

                return name ? name : c.name;
            }}
            showAll
            isOptionEqualToValue={(option, value) => option.__id === value.__id}
            multiSearchColumnName={['title', 'firstName', 'familyName']}
            renderLocalOption={renderOptionLine}
            dictionaryURL={getDictionaryURL}
            noBorder={false}
            withBackground={false}
            {...props}
        />
    );
}

function Relationship(props) {
    const getDictionaryURL = (filter) => {
        if (props.fromAdmit) {
            return `/$dict/Relationships?$filter=${encodeURIComponent(
                filter,
            )}&$sort=description&$pageSize=10&$page=1`;
        }
        return `/$dict/Relationships?$filter=${encodeURIComponent(
            filter,
        )}&$sort=sort1&$pageSize=10&$page=1`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return (
        <AutocompleteDictionary
            getOptionLabel={(option) => option.__description}
            showAll
            searchColumnName={'description'}
            renderLocalOption={renderOptionLine}
            dictionaryURL={getDictionaryURL}
            {...props}
        />
    );
}

//TODO: add availableIn strategy
function AdmissionConsultant(props) {
    const getDictionaryURL = (filter) => {
        return `/admission/person/consultant?filter=${filter}&pageSize=100&page=1`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.name}</div>;
    };

    const renderTags = (tagValue, getTagProps) => tagValue.map((option, index) => (
        <Chip
            size={props.size}
            color={props.color}
            label={option.name}
            style={props.style}
            {...getTagProps({index})}
        />
    ));


    return <AutocompleteDictionary getOptionLabel={option => option.name}
                                   isOptionEqualToValue={(option, value) => {
                                       return option.id === value.id;
                                   }}
                                   searchColumnName={'name'}
                                   renderLocalOption={renderOptionLine}
                                   renderTags={renderTags}
                                   dictionaryURL={getDictionaryURL}
                                   showAll
                                   noRegex
                                   dataType={'admission'}
                                   noBorder={false}
                                   size="large"
                                   {...props}
    />;
}

//TODO: add availableIn strategy
function AdmissionConsultantDropdown(props) {
    const getDictionaryURL = (filter) => {
        return `/admission/person/consultant?filter=${filter}&pageSize=100&page=1`;
    };


    const renderTags = (tagValue, getTagProps) => tagValue.map((option, index) => (
        <Chip
            size={props.size}
            color={props.color}
            label={option.name}
            {...getTagProps({index})}
        />
    ));


    return <AutocompleteDropdownDictionary getOptionLabel={option => option.name}
                                           isOptionEqualToValue={(option, value) => {
                                               return option.id === value.id;
                                           }}
                                           pathToEqualValue={'id'}
                                           path={'name'}
                                           searchColumnName={'name'}
                                           renderTags={renderTags}
                                           dictionaryURL={getDictionaryURL}
                                           showAll
                                           noRegex
                                           dataType={'admission'}
                                           noBorder={false}
                                           size="large"
                                           {...props}
    />;
}

//TODO: add availableIn strategy
function AdmissionSurgeon(props) {
    const getDictionaryURL = (filter) => {
        return `/admission/person/surgeon?filter=${filter}&pageSize=100&page=1`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.name}</div>;
    };

    return <AutocompleteDictionary getOptionLabel={option => option.name}
                                   isOptionEqualToValue={(option, value) => {
                                       return option.name === value.name;
                                   }}
                                   searchColumnName={'name'}
                                   renderLocalOption={renderOptionLine}
                                   dictionaryURL={getDictionaryURL}
                                   showAll
                                   noRegex
                                   dataType={'admission'}
                                   noBorder={false}
                                   size="large"
                                   {...props}
    />;
}

//TODO: add availableIn strategy
function AdmissionSurgeonDropdown(props) {
    const getDictionaryURL = (filter) => {
        return `/admission/person/surgeon?filter=${filter}&pageSize=100&page=1`;
    };


    const renderTags = (tagValue, getTagProps) => tagValue.map((option, index) => (
        <Chip
            size={props.size}
            color={props.color}
            label={option.name}
            {...getTagProps({index})}
        />
    ));


    return <AutocompleteDropdownDictionary getOptionLabel={option => option.name}
                                           isOptionEqualToValue={(option, value) => {
                                               return option.name === value.name;
                                           }}
                                           pathToEqualValue={'name'}
                                           path={'name'}
                                           searchColumnName={'name'}
                                           renderTags={renderTags}
                                           dictionaryURL={getDictionaryURL}
                                           showAll
                                           noRegex
                                           dataType={'admission'}
                                           noBorder={false}
                                           size="large"
                                           {...props}
    />;
}

//TODO: add availableIn strategy
function AdmissionAnaesthetist(props) {
    const getDictionaryURL = (filter) => {
        return `/admission/person/anaesthetist?filter=${filter}&pageSize=100&page=1`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.name}</div>;
    };

    return <AutocompleteDictionary getOptionLabel={option => option.name}
                                   isOptionEqualToValue={(option, value) => {
                                       return option.name === value.name;
                                   }}
                                   searchColumnName={'name'}
                                   renderLocalOption={renderOptionLine}
                                   dictionaryURL={getDictionaryURL}
                                   showAll
                                   noRegex
                                   dataType={'admission'}
                                   noBorder={false}
                                   size="large"
                                   {...props}
    />;
}

//TODO: add availableIn strategy
function AdmissionAnaesthetistDropdown(props) {
    const getDictionaryURL = (filter) => {
        return `/admission/person/anaesthetist?filter=${filter}&pageSize=100&page=1`;
    };


    const renderTags = (tagValue, getTagProps) => tagValue.map((option, index) => (
        <Chip
            size={props.size}
            color={props.color}
            label={option.name}
            {...getTagProps({index})}
        />
    ));


    return <AutocompleteDropdownDictionary getOptionLabel={option => option.name}
                                           isOptionEqualToValue={(option, value) => {
                                               return option.name === value.name;
                                           }}
                                           pathToEqualValue={'name'}
                                           path={'name'}
                                           searchColumnName={'name'}
                                           renderTags={renderTags}
                                           dictionaryURL={getDictionaryURL}
                                           showAll
                                           noRegex
                                           dataType={'admission'}
                                           noBorder={false}
                                           size="large"
                                           {...props}
    />;
}

function AdmissionSpecialties(props) {
    const getDictionaryURL = (filter) => {
        if (props.showAll) {
            return `/$dict/DepartmentType`;
        }
        //return `/$dict/AdmissionSpecialties?$filter=${encodeURIComponent(filter)}&$pageSize=10&$page=1`;
        if (filter) filter += ' and ';
        filter += 'metadata.bookAdmission eq true';
        return `/$dict/Specialties?$filter=${encodeURIComponent(filter)}&$pageSize=50&$page=1&$sort=description`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    const renderTags = (tagValue, getTagProps) => tagValue.map((option, index) => (
        <Chip
            size={props.size}
            color={props.color}
            label={option.__description}
            {...getTagProps({index})}
        />
    ));

    return <AutocompleteDictionary getOptionLabel={option => option.__description}
                                   isOptionEqualToValue={(option, value) => option.__id === value.__id}
                                   searchColumnName={'description'}
                                   renderLocalOption={renderOptionLine}
                                   dictionaryURL={getDictionaryURL}
                                   renderTags={renderTags}
                                   noBorder={false}
                                   size="large"
                                   showAll
                                   {...props}
    />;
}

function AdmissionSpecialtiesDropdown(props) {
    const getDictionaryURL = (filter) => {
        if (props.showAll) {
            return `/$dict/DepartmentType`;
        }
        if (filter) filter += ' and ';
        filter += 'metadata.bookAdmission eq true';
        return `/$dict/Specialties?$filter=${encodeURIComponent(filter)}&$pageSize=10&$page=1&$sort=description`;
    };


    return <AutocompleteDropdownDictionary getOptionLabel={option => option.__description}
                                           isOptionEqualToValue={(option, value) => option.__id === value.__id}
                                           searchColumnName={'description'}
                                           path={'__description'}
                                           pathToEqualValue={'__id'}
                                           dictionaryURL={getDictionaryURL}

                                           noBorder={false}
                                           size="large"
                                           showAll
                                           {...props}
    />;
}

function MedicalDayUnit(props) {
    const getDictionaryURL = (filter) => {


        return `/$dict/MedicalDayUnits`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return <AutocompleteDictionary getOptionLabel={option => option.description}
                                   isOptionEqualToValue={(option, value) => option.__description === value.description}
                                   searchColumnName={'__description'}
                                   renderLocalOption={renderOptionLine}
                                   dictionaryURL={getDictionaryURL}
                                   showAll
                                   {...props}
    />;
}

export {
    ReferralTreatmentStatus,
    WaitingTimeMeasurementType,
    WithheldIdentityReason,
    OverseasVisitorChargingCategory,
    MentalHealthClassification,
    DepartmentType,
    AttendanceCategory,
    ActivityTreatment,
    ActivityTreatmentECDS,
    ClinicianIssuerCode,
    ClinicianTier,
    DelayReason,
    ClinicalFrailtyScale,
    NHSStatusCode,
    ObsSuspendReason,
    Relationship,
    Location,
    AdmissionConsultant,
    AdmissionSpecialties,
    AdmissionSurgeon,
    AdmissionAnaesthetist,
    MedicalDayUnit,
    AttendanceType,
    AdmissionConsultantDropdown,
    AdmissionSpecialtiesDropdown,
    AdmissionSurgeonDropdown,
    AdmissionAnaesthetistDropdown,
    Consultants,
    ConsultationMechanism,
};